import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicatiiCasatoriiComponent } from './publicatii-casatorii.component';
import { AddPublicatieComponent } from './add-publicatie/add-publicatie.component';
import { EditPublicatieComponent } from './edit-publicatie/edit-publicatie.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        PublicatiiCasatoriiComponent,
        AddPublicatieComponent,
        EditPublicatieComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [PublicatiiCasatoriiComponent]
})
export class PublicatiiCasatoriiModule { }
